// The letter template's card (platform П9) and the transport of the letters in the section «Письма» (platform П10).
// The app «Письма» lives in the core, so its tabs and notices are registered here, not by the product's web entry.

import { registerRecordHome, registerRecordTabs, registerScreens, registerSectionNav, registerTypeNotices } from '../shell/screens.ts';
import { MailFoot, MailNav, useMailTitle } from './client/Folders.tsx';
import { MailScreen } from './client/MailScreen.tsx';
import { MailTransportNotice } from './MailTransportNotice.tsx';
import { TemplatePreview } from './TemplatePreview.tsx';
import { TemplateSent } from './TemplateSent.tsx';
import { CampaignLetters } from './CampaignLetters.tsx';

registerRecordTabs('email_template', [
  { key: 'preview', label: 'Просмотр', component: TemplatePreview },
  { key: 'sent', label: 'Отправлено', component: TemplateSent },
]);

// J6: who got the letters of a run and how each went.
registerRecordTabs('email_campaign', [{ key: 'letters', label: 'Получатели', component: CampaignLetters }]);

// The mail client (R-M6): the rail button «Письма» opens it; its folders fill the section's left column on every page of the section
// (um/2026-10-30/03 п.1), and a letter or a mailbox found elsewhere (the search, an old address) opens in the client, not as a page.
registerScreens({ mail: MailScreen });
registerSectionNav('mail', { nav: MailNav, useTitle: useMailTitle, foot: MailFoot });
registerRecordHome('mail_letter', (id) => `/s/mail?letter=${id}`);
registerRecordHome('mailbox', () => '/s/mail');

registerTypeNotices('email_message', [{ key: 'mail-transport', component: MailTransportNotice }]);
registerTypeNotices('email_template', [{ key: 'mail-transport', component: MailTransportNotice }]);

export { MailTransportNotice } from './MailTransportNotice.tsx';
export { TemplatePreview } from './TemplatePreview.tsx';
export { TemplateSent } from './TemplateSent.tsx';
export { TemplateTestButton } from './TemplateTestButton.tsx';
export { templateNames, templateParts } from './preview.ts';
export { RecordLetters } from './client/RecordLetters.tsx';
